module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    attrs: {
      "options": _vm.options,
      "show-labels": false,
      "track-by": "title",
      "label": "title",
      "placeholder": "Выбрать период"
    },
    on: {
      "select": _vm.handleChangeParse
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d616976"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/ParsePeriod.vue
// module id = 544
// module chunks = 0